"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Public = _interopRequireDefault(require("@material-ui/icons/Public"));

var _Button = _interopRequireDefault(require("../Button"));

var View = function View(_ref) {
  var isOpen = _ref.isOpen,
      timezone = _ref.timezone,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    disableBackdropClick: true,
    maxWidth: "xs",
    open: isOpen,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-10 pt-4 text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl text-primary leading-relaxed"
  }, /*#__PURE__*/_react["default"].createElement(_Public["default"], {
    fontSize: "inherit"
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "px-4 text-dark font-bold"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-block"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "inboxBreak.scheduledBreak.timezone.confirm",
    values: {
      timezone: timezone
    }
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: "text-primary"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-10"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    onClick: onConfirm,
    className: "w-56 ml-2 text-dark"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "button.useTimezone",
    values: {
      timezone: _momentTimezone["default"].tz.guess()
    }
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: "text-primary"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-1"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-light text-sm",
    onClick: onClose
  }, t('button.noThanks'))))));
};

View.displayName = 'TimezoneConfirm';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=TimezoneConfirm.js.map